import React, { useState, useEffect } from 'react';
import { RouteComponentProps } from 'react-router';
import Loader from '../components/Loader';
import { createUseStyles } from 'react-jss';
import { getByUsername } from '../services/ApiService';
import { Product, User,Article, Business as BusinessType, Twig } from '../types';
import { getTwigSkeleton } from '../services/helpers';
import DefaultLayout from '../layouts/DefaultLayout';
import TwigDetails from './TwigDetails';
import Profile from './Profile';
import ProductDetails from './ProductDetails';
import FullPageError from '../components/FullPageError';
import Business from './Business';


import { Helmet } from 'react-helmet';
import ArticleDetails from './ArticleDetails';


export interface GetByIdProps
  extends RouteComponentProps<{
    id: string;
  }> {
  history: any
}
const GetById: React.FC<GetByIdProps> = ({
  match: {
    params: { id },
  },
  history
},) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [data, setData] = useState<Twig | Product | User | BusinessType|Article>(
    getTwigSkeleton(),
  );
  const [type, setType] = useState<'twig' | 'product' | 'user' | 'business' |'article' >('twig');

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const response = await getByUsername(id);
        setData(response.data);
        setType(response.type);
      } catch (e) {
        setError(true);
      }
      setLoading(false);
    })();
  }, [id]);

  return (
    <>
      <Helmet>
        <title>twigBIG</title>
      </Helmet>
      <DefaultLayout history={history}>
        <Loader className={classes.loader} loading={loading} center>
          {() => {
            if (error) {
              return (
                <div className={classes.errorBox}>
                  <FullPageError title="404 Not Found" />
                </div>
              );
            } else if (type === 'twig') {
              return <TwigDetails twig={data as Twig} />;
            } else if (type == 'user') {
              return <Profile user={data as User} />;
            } else if (type === 'product') {
              return <ProductDetails product={data as Product} />;
            } else if (type == 'business') {
              return <Business business={data as BusinessType} />;
            }
              else if(type=="article"){
              return <ArticleDetails article={data as Article} />;
            }
            return <div />;
          }}
        </Loader>
      </DefaultLayout>
    </>
  );
};
const useStyles = createUseStyles({
  loader: {
    minHeight: '70vh',
  },
  errorBox: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '70vh',
  },
});
export default GetById;